export default "__VITE_ASSET__517ef6f2__"